import { FC } from "react";

import { hasReadiedUsersReachedMaxGroupSize } from "components/materials/page/groups/helpers";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { RoundedButton } from "mds/components/buttons/RoundedButton";
import { PersonGroupIcon } from "mds/icons";
import { storeApi, useAppSelector } from "store/index";
import {
  pageSelectors,
  selectCurrentSectionUserId,
  selectNestedPageGroupForUser,
} from "store/selectors";
import { useObjectSelector } from "store/store-hooks";

interface ConfirmGroupButtonProps {
  pageId: string;
  userId: string;
}

export const ConfirmGroupButton: FC<ConfirmGroupButtonProps> = ({ pageId, userId }) => {
  const page = useObjectSelector(
    (s) => pageSelectors.selectById(s, pageId),
    ["title", "max_group_size"],
  );
  const pageGroup = useAppSelector((s) => selectNestedPageGroupForUser(s, pageId, userId));
  const sectionUserId = useAppSelector(selectCurrentSectionUserId);

  if (!page) {
    return null;
  }

  const pageGroupUser = pageGroup?.page_group_users.find(
    (pgu) => pgu.section_user_id === sectionUserId,
  );
  const isDisabled = !pageGroup || hasReadiedUsersReachedMaxGroupSize(pageGroup, page);

  const onConfirmGroup = async () => {
    if (!pageGroupUser) return;
    await storeApi.page_group_users.partial_update({
      id: pageGroupUser.id,
      is_ready: true,
    });
  };

  return (
    <RoundedButton
      disabled={isDisabled}
      eventName="Student Page - Confirm Group"
      eventProps={{ pageTitle: page.title, pageId }}
      kind="success"
      onClick={onConfirmGroup}
    >
      <IconText iconStart={<PersonGroupIcon />} text={t("page_view.confirm_group")} />
    </RoundedButton>
  );
};
